import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

type ErrorMessageProps = HTMLAttributes<HTMLParagraphElement>

const ErrorMessage = forwardRef<HTMLParagraphElement, ErrorMessageProps>(
  ({ children, className, ...rest }, ref) => {
    return (
      <p ref={ref} className={cn(styles.root, className)} {...rest}>
        {children}
      </p>
    )
  },
)

ErrorMessage.displayName = 'ErrorMessage'

export default ErrorMessage
